import { MarketingSignUpParamsDto, MarketingSignUpParamsKey } from '../model/marketing-sign-up-params.dto';

const marketingUtmParamsLocalStorageKey = 'tallo_utm_params';
const marketingUtmParamsKeys: MarketingSignUpParamsKey[] = ['utm_source', 'utm_medium', 'utm_campaign'];

class MarketingSignUpParamsService {
  captureUtmParams(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const marketingUtmParams: MarketingSignUpParamsDto = {};
    let hasUtmParams = false;

    marketingUtmParamsKeys.forEach((param: MarketingSignUpParamsKey) => {
      const value = urlParams.get(param);
      if (value) {
        marketingUtmParams[param] = value;
        hasUtmParams = true;
      }
    });

    if (hasUtmParams) {
      localStorage.setItem(marketingUtmParamsLocalStorageKey, JSON.stringify(marketingUtmParams));
    }
  }

  getUtmParams(): MarketingSignUpParamsDto | null {
    const storedParams = localStorage.getItem(marketingUtmParamsLocalStorageKey);
    if (!storedParams) {
      return null;
    }

    try {
      return JSON.parse(storedParams);
    } catch (e) {
      console.error('Error parsing UTM parameters from localStorage', e);
      return null;
    }
  }
}

export default new MarketingSignUpParamsService();
